import styled from "styled-components";
import { backBanner, breakpoints } from "@/shared/Constants";

export const ContetBanner = styled.div`
  display: flex;
  justify-content: center;

  &#div-gpt-ad-horizontal1 {
    margin-bottom: 0;
    max-height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    ${breakpoints.mobileFirst} {
      min-height: 200px;
    }
  }
  &.lazyBanner,
  &.bannerSRA {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    width: -webkit-fill-available;
    ${breakpoints.phone} {
      width: unset;
    }
  }
  &.bannerSRA#div-gpt-ad-horizontal1 {
    width: unset;
  }

  &#div-gpt-ad-horizontal-premium {
    padding-top: 10px !important;
  }
`;
export const DummyBanner = styled.div`
  overflow: hidden;
  max-width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 300px;
  width: 300px;
  ${backBanner}
  &.logocajagranos, &.logo {
    height: 50px;
  }
`;
